module.exports = __webpack_public_path__ + "static/media/peron.bcb495fa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/peron.mp3
// module id = 33
// module chunks = 0